import icon1 from "assets/icons/af-1.png";
import icon2 from "assets/icons/af-2.png";
import icon3 from "assets/icons/af-3.png";

export const AffiliateProgramsList = [
   {
      id: 1,
      icon: icon1,
      title: "Marketing Assets",
      descriptiom:
         "Easy to download promotional tools such as banners, coupons, links, videos and documents to aid marketing.",
   },
   {
      id: 2,
      icon: icon2,
      title: "20% recurring commission",
      descriptiom:
         "Get a 20% commission for every referral, and get an additional 20% commission for every recurring payment.",
   },
   {
      id: 3,
      icon: icon3,
      title: "Round-the-clock support",
      descriptiom:
         "Get direct access to an affiliate manager to answer all your questions and provide support and directions when you need them.",
   },
];
